import _styled from '@emotion/styled/base';
import isPropValid from '@emotion/is-prop-valid';
import { keyframes } from '@emotion/react';
import { Spacer } from '../primitives/Spacer/index.js';
import { opacity, text, border, motion } from '@hubble/tokens/web';

const loading = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(100% + 200px);
  }
`;
const SkeletonLoader = _styled(Spacer, {
  shouldForwardProp: propName => isPropValid(propName) && !['height', 'radiusSize', 'width'].includes(propName),
  target: "ekje9tr0"
})("opacity:", ({
  theme
}) => theme.isDark ? opacity.skeleton.darkMode : opacity.skeleton.lightMode, ";background-size:200px;background-color:", ({
  theme
}) => theme.colorScheme.skeleton.background, ";height:", ({
  height = text.typesets.body.sm.fontSize
}) => height, ";width:", ({
  width = '75% '
}) => width, ";border-radius:", ({
  radiusSize = 'sm'
}) => border.radius[radiusSize], ";flex:none;background-repeat:no-repeat;background-image:", ({
  theme
}) => {
  const background = theme.colorScheme.skeleton.background;
  const foreground = theme.colorScheme.skeleton.foreground;
  return `linear-gradient(
        90deg,
        ${background},
        ${foreground},
        ${background},
        ${background}
      );`;
}, ";animation:", loading, " ", motion.duration.skeleton, " infinite ease-in-out;/* https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion */@media (prefers-reduced-motion){animation:", loading, " 8s infinite ease-in-out;}");

export { SkeletonLoader };
